// FAQPage.js

import React from "react";

const FAQPage = () => {
  // Define your FAQ data
  const faqs = [
    {
      question: "What is Telephone Directory about?",
      answer:
        "Telephone Directory is a telephone directory app designed for organizations to manage and access employee contact information conveniently.",
    },
    {
      question: "How can organizations contact us to use the app?",
      answer:
        'Organizations interested in using our app can contact us via email at <a href="mailto:info@code-b.dev" style="color: blue; text-decoration: underline;">info@code-b.dev</a>.',
    },
    {
      question: "What kind of information does Telephone Directory collect?",
      answer:
        "Telephone Directory collects phone numbers of employees within organizations. This information is necessary for the app's functionality.",
    },
    {
      question: "Can users delete their information from the app?",
      answer:
        'Yes, users can request the deletion of their information by sending an email to <a href="mailto:info@code-b.dev" style="color: blue; text-decoration: underline;">info@code-b.dev</a>. Upon receiving the request, we will deactivate their app account and remove their data from our system.',
    },
    {
      question: "Is user data secure?",
      answer:
        "Yes, we prioritize the security and privacy of user data. We adhere to strict data protection measures to safeguard user information from unauthorized access or misuse.",
    },
    {
      question: "How frequently is the app updated?",
      answer:
        "We strive to regularly update Telephone Directory to enhance its features, performance, and security. Users will be notified of any updates through the app store.",
    },
    {
      question: "What platforms is the app available on?",
      answer:
        "Telephone Directory is available for download on both iOS and Android platforms.",
    },
    {
      question: "How can users provide feedback or report issues?",
      answer:
        'Users can provide feedback or report any issues by contacting our support team via email at <a href="mailto:info@code-b.dev" style="color: blue; text-decoration: underline;">info@code-b.dev</a>.',
    },
  ];

  return (
    <div style={{ maxWidth: "800px", margin: "0 auto", padding: "20px" }}>
      <h1
        style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "20px" }}
      >
        Telephone Directory FAQ
      </h1>
      <div>
        {faqs.map((faq, index) => (
          <div key={index} style={{ marginBottom: "20px" }}>
            <h3 style={{ fontWeight: "bold", marginBottom: "10px" }}>
              {index + 1}. {faq.question}
            </h3>
            <p
              style={{ fontSize: "16px", lineHeight: "1.5" }}
              dangerouslySetInnerHTML={{ __html: faq.answer }}
            ></p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQPage;
